import AMONKEY_EXT_1 from "./AMONKEY_EXT_1";

export default {
  AMONKEY_EXT_1,
};
